import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated root one-off URLs (profile, inbox, expenses, search).
 *
 * Kept separate from `root.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 */
export const profileRoute = defineRoute("/profile");
export const inboxRoute = defineRoute("/inbox");
export const expensesRoute = defineRoute("/expenses");
export const searchRoute = defineRoute("/search");
